// Wait for PagSeguro to be loaded
const waitForPagSeguro = () => {
    return new Promise((resolve, reject) => {
        if (window.PagSeguro) {
            resolve(window.PagSeguro);
            return;
        }

        // Check every 100ms if PagSeguro is loaded
        const checkInterval = setInterval(() => {
            if (window.PagSeguro) {
                clearInterval(checkInterval);
                resolve(window.PagSeguro);
            }
        }, 100);

        // Timeout after 10 seconds
        setTimeout(() => {
            clearInterval(checkInterval);
            reject(new Error('PagSeguro script failed to load'));
        }, 15000);
    });
};

export const createEncryptedCard = async (cardHolder, cardNumber, cardExpMonth, cardExpYear, cardCVC) => {
    try {
        // Wait for PagSeguro to be available
        const PagSeguro = await waitForPagSeguro();
        
        return PagSeguro.encryptCard({
            publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzajtPY+xlXLYJ8ZWlZZJpctUuBSvHn5sM9jec1NbPuPLF4ehbPLsHoqCRlhqWcKSzjX9zdbrwz6KcN7zavZ5xLl8/xQk6Zc9suBsb4HimTWOJMiLGDQP55EgmwkrsdO2cES5TbZyOylvrKRhDawpyEJp+ATxZvgFkaE2iQr9Suh3oaIt15vUKO+Baep3110l2hqfcsrSwWKD70y+SM16ELWJfoQ4KV3D3p12sxCN1el0dE0iE3DAurbErRFmhRH4lxURlDbIC1Ld8i1Z+RHauYkaR7nq+qTiotNQhmhyliL9mgFIH1EFTD680XV+VTngPb7ETOAFTMJher1jWb0GcwIDAQAB",
            number: cardNumber,
            holder: cardHolder,
            expMonth: cardExpMonth,
            expYear: cardExpYear,
            securityCode: cardCVC
        });
    } catch (error) {
        console.error("Error creating encrypted card:", error);
        throw error;
    }
}
